/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_appsync_graphqlEndpoint": "https://qboftuv3gjdw5j2esdwlhmoeu4.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "ap-south-1:7f31c157-cc88-4cbd-889b-73fe69dae713",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_mAmysSrIB",
    "aws_user_pools_web_client_id": "6p25l3ks5rovbdqs5vmcvhjhna",
    "oauth": {
        domain: "denali-prodind.auth.ap-south-1.amazoncognito.com",
        scope: ["openid", "profile", "aws.cognito.signin.user.admin"],
        redirectSignIn: window.location.origin,
        redirectSignOut: `https://corpsso.b2clogin.com/corpsso.onmicrosoft.com/B2C_1A_OIDC_USERINFO_DENALI/oauth2/v2.0/logout?post_logout_redirect_uri=${window.location.origin}`,
        responseType: "code",
        client_id: "505ef98d-3c71-4d31-9a47-808eb98d30ad"
    },
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "denali-analytics-validation-storage162241-prodind",
    "aws_user_files_s3_bucket_region": "ap-south-1",
    "predictions": {
        "convert": {
            "translateText": {
                "region": "ap-south-1",
                "proxy": false,
                "defaults": {
                    "sourceLanguage": "en",
                    "targetLanguage": "fr"
                }
            }
        }
    },
    "geo": {
        "amazon_location_service": {
            "region": "ap-south-1",
            "search_indices": {
                "items": [
                    "denalilocator-prodind"
                ],
                "default": "denalilocator-prodind"
            },
            "maps": {
                "items": {
                    "denalimap-prodind": {
                        "style": "VectorEsriNavigation"
                    }
                },
                "default": "denalimap-prodind"
            }
        }
    },
    "appEnvironment": {
        "BUILD_ENV": "prod",
        "externalLinks": {
          "traneConnectBaseURL": "https://connect.tis.tranetechnologies.in",
          "commandCenterBaseURL": "https://tcc.tis.tranetechnologies.in",
          "commandCenterGen4BaseURL": "https://gen4.tcc.tis.trane.com"
        }
    }
};

export const APP_ID = "9b308188-33ad-4a84-8974-a412dc03e3f6"
export const signOutUrl = `https://${awsmobile.oauth.domain}/logout?client_id=${awsmobile.aws_user_pools_web_client_id}&logout_uri=${awsmobile.oauth.redirectSignOut}&redirect_uri=${window.location.origin}&response_type=code`
export const remoteAccessURL = 'https://prod.api.tis.tranetechnologies.in/remoteaccess/connect'
export const openVPNURL = 'https://api.tis.tranetechnologies.in/v2/remote'
export const amplitudeKey = "" //"9b308188-33ad-4a84-8974-a412dc03e3f6"
export const zendeskWidgetKey = "f42546cb-115b-4d5d-bf44-b4ddab8f10cd"
export const staticFilesPath = "https://denali-staticfiles-m5s4wy2zxzacpndppmyu6ybwoa-prodind.s3.amazonaws.com"

export const REACT_APP_API_ENDPOINT =
  "https://g9v0inu094.execute-api.us-east-1.amazonaws.com/dev/generate"
export const llmClientId = "pD6dOZoWO92F3MG0LIh5n8YtpivrdeIn7XWrc4Bw"

export const aiChatWebSocketURL="wss://f7tegwhhq8.execute-api.ap-south-1.amazonaws.com/prodind/"

export default awsmobile;
